import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CircularProgressBar from '../CircularProgressBar/CircularProgressBar';

export default class NotificationItem extends Component {
    constructor(props) {
        super(props);
        this.timer = null;

        this.close = this.close.bind(this);

        this.state = { isOpen: true };
    }

    componentDidMount() {
        if (this.props.event.time) {
            this.timer = setTimeout(() => {
                this.close();
            }, this.props.event.time);
        }
    }

    componentWillUnmount() {
        if (this.props.event !== 0) clearTimeout(this.timer);
    }

    close() {
        if (!this.props.closeDelegate) {
            return;
        }

        this.setState({ isOpen: false }, () => {
            setTimeout(() => {
                this.props.closeDelegate(this.props.event);
            }, 1000);
        });
    }

    render() {
        const { event, closeDelegate } = this.props;
        const slideClassName = this.state.isOpen ? 'slide-in' : 'slide-out';
        const debugId = 'Notifications_Item';

        return (
            <div
                className={classNames('notification-item', event.style, slideClassName)}
                data-error-id={event.errorId}
                data-error-status={event.errorStatus}
                data-error-uri={event.errorUri}
                data-debug-id={debugId}
            >
                <div className="notification-item-icon" />

                <div className="notification-item-description" title={event.text} data-debug-id={`${debugId}_Description`}>
                    {event.text}
                </div>

                {event.repeat > 0 && (
                    <div className="notification-item-counter" data-debug-id={`${debugId}_Counter`}>
                        {event.repeat + 1}
                    </div>
                )}

                <div className="action-box">
                    {closeDelegate && (
                        <button className="notification-item-close-btn" onClick={this.close} data-debug-id={`${debugId}_Close_Btn`}>
                            {event.time && <CircularProgressBar className="close-progress-bar" duration={event.time} />}
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

NotificationItem.propTypes = {
    event: PropTypes.object.isRequired,
    closeDelegate: PropTypes.func,
    lastAction: PropTypes.func,
};
